'use strict';

/**
 *
 * @name: addonBrightcove
 *
 */

import DirectiveTemplate from './nn-addon-brightcove.directive.html';
import './nn-addon-brightcove.directive.scss';

function AddonBrightcoveDirective() {

  'ngInject';

  return {
    restrict: 'CA',
    replace: true,
    transclude: false,
    template: DirectiveTemplate,
    link: function(scope, element, attrs) {


      scope.brightcoveSettings = {
        item: null,
        src: null
      };

      scope.post.media.some(function(item) {

        if (item.key === attrs.mediaKey) {

          scope.brightcoveSettings.item = item;
          scope.brightcoveSettings.src = item.content;
          return true;
        }
        return false;
      });
    }
  };
}

export default AddonBrightcoveDirective;



// WEBPACK FOOTER //
// ./app/components/nn-add-ons/nn-addon-brightcove/nn-addon-brightcove.directive.js